var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_4465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70604 11.7365C6.76513 11.8994 6.76513 12.078 6.70604 12.2409L3.79979 20.745C3.74783 20.8885 3.74093 21.0445 3.77999 21.1921C3.81906 21.3397 3.90224 21.4718 4.01842 21.5709C4.13459 21.67 4.27823 21.7312 4.43014 21.7464C4.58205 21.7617 4.735 21.7302 4.86854 21.6562L20.6185 12.6478C20.7358 12.5829 20.8335 12.4878 20.9015 12.3724C20.9696 12.257 21.0054 12.1255 21.0054 11.9915C21.0054 11.8575 20.9696 11.726 20.9015 11.6106C20.8335 11.4952 20.7358 11.4001 20.6185 11.3353L4.86854 2.34933C4.73533 2.27483 4.58256 2.24274 4.43063 2.25735C4.2787 2.27197 4.13484 2.33259 4.01828 2.43112C3.90171 2.52965 3.81798 2.6614 3.77827 2.80878C3.73856 2.95615 3.74476 3.11213 3.79604 3.25589L6.70604 11.7365Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12H6.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_4465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendNotification);
export default __webpack_public_path__ + "static/media/send_notification.f51710e7c70f950241a9d5312a0af10e.svg";
export { ForwardRef as ReactComponent };